import { CourseProduct } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { readHasActiveOffering, readIsUsedInActivePackage } from "./productDtoHelpers";
import { attachUnitTypeTextToCourses } from "./getCourseProducts";

export async function getCourseById(divisionId: number, courseId: string):Promise<CourseProduct|void> {
    const localApi = await getLocalApi();

    const row = await localApi.fetchSingle(apiConfig.courses_get_by_id.replace("{divisionId}", divisionId.toString()).replace("{courseId}", courseId),
    mapCourseProduct,
    "Failed to fetch course product byId");
    if (row == null) return;
    const [enriched] = await attachUnitTypeTextToCourses([row]);
    return enriched;
}

function mapCourseProduct(courseProduct: any): CourseProduct {
    const hasClosureDate = courseProduct.closureDate != null && courseProduct.closureDate !== '';
    const activeFromApi = typeof courseProduct.active === 'boolean' ? courseProduct.active : true;
    const active = !hasClosureDate && activeFromApi;
    return {
        id: courseProduct.productId,
        name: courseProduct.productName,
        lastModifiedDate: courseProduct.lastModifiedDate,
        lastUpdatedBy: courseProduct.lastModifiedBy,
        division: courseProduct.divisionId,
        divisionText:courseProduct.division,
        intensityId: courseProduct.courseIntensityId,
        intensityText: courseProduct.courseIntensityText,
        entityUpdate: courseProduct.entityUpdate,
        closureDate: courseProduct.closureDate ? new Date(courseProduct.closureDate) : null,
        productCategoryId: courseProduct.productCategoryId,
        accountCategoryId: courseProduct.accountCategoryId,
        CourseProduct: courseProduct.CourseProduct || false,
        languageId: courseProduct.courseLanguageId,
        languageText: courseProduct.courseLanguageText,
        productCategoryText: courseProduct.productCategoryText,
        accountCategoryText: courseProduct.accountCategoryText,
        active,
        excludedBookingSystemIds: [],
        minimumAge: courseProduct.minimumAge ?? null,
        minimumWeeks: courseProduct.minimumWeeks ?? null,
        unitTypeId:
          courseProduct.unitTypeId != null && String(courseProduct.unitTypeId).trim() !== ""
            ? Number(courseProduct.unitTypeId)
            : undefined,
        unitTypeText:
          courseProduct.unitTypeText != null
            ? String(courseProduct.unitTypeText)
            : courseProduct.unitTypeName != null
              ? String(courseProduct.unitTypeName)
              : undefined,
        hasActiveOffering: readHasActiveOffering(courseProduct),
        isUsedInActivePackage: readIsUsedInActivePackage(courseProduct),
    }
}